import { toast } from "@/view/components/ui/use-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HandleLeadStatusParams } from "../services/leadsService/handleLeadStatus";
import { leadsService } from "../services/leadsService";
import { CreateLeadPayload } from "../services/leadsService/createLead";
import { UpdateLeadPayload } from "../services/leadsService/updateLead";

export const useLeadMutations = () => {
  const queryClient = useQueryClient();

  const updateStatus = useMutation({
    mutationFn: (input: HandleLeadStatusParams) =>
      leadsService.handleLeadStatus(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["leads"] });
      toast({
        title: "Lead atualizado com sucesso.",
      });
    },
    onError: (error: any) => {
      const message =
        error?.message ?? "Erro ao atualizar lead. Tente novamente mais tarde.";

      toast({
        variant: "destructive",
        title: message,
      });
    },
  });

  const createLead = useMutation({
    mutationFn: (input: CreateLeadPayload) => leadsService.createLead(input),
  });

  const updateLead = useMutation({
    mutationFn: (input: UpdateLeadPayload) => leadsService.updateLead(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["leads"] });
    },
  });

  return {
    updateLeadStatus: updateStatus.mutateAsync,
    isUpdatingLeadStatus: updateStatus.isPending,

    createLead: createLead.mutateAsync,
    isCreatingLead: createLead.isPending,

    updateLead: updateLead.mutateAsync,
    isUpdatingLead: updateLead.isPending,
  };
};
